import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Global MFA lockdown.
 *
 * Once a user has passed password auth but still needs the TOTP step,
 * the app must not allow browsing anywhere except the MFA challenge route.
 */
export const MfaRouteEnforcer = () => {
  const { user, loading, mfaRequired } = useAuth();
  const location = useLocation();

  if (loading || !user || !mfaRequired) return null;
  if (location.pathname === "/auth/mfa") return null;

  return <Navigate to="/auth/mfa" replace state={{ from: location }} />;
};

export default MfaRouteEnforcer;